import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useAxios from "../../../hooks/use-axios";
import RLEmptyListCard from "../../UI/RLModal/RLEmptyListCard";
import Wrapper from "../../UI/Wrapper";
import PanelGuardianChart from "./PanelGuardianChart";
import PanelGuardianForm from "./PanelGuardianForm";
import PanelGuardianList from "./PanelGuardianList";
import PanelContentTop from "../PanelContentTop";

const PanelGuardian = (props) => {
  const { t } = useTranslation();

  const params = useParams();
  let graveId = params["graveId"];

  const [guardians, setGuardians] = useState([]);

  const { response, loading, error, request, responseType } = useAxios();
  const [endpoint, setEndpoint] = useState("first");
  const [reload, setReload] = useState(false);

  const rlSideBar = props.rlSideBar
  const selectedGrave = rlSideBar.selectedGrave

  useEffect(() => {
    getGuardiansList();
  }, [selectedGrave]);

  useEffect(() => {

    if (response !== null && typeof response !== "undefined") {
      if (responseType == "grave/" + graveId + "/assignment/guardian/list") {
        const loadedGuardians = [];

        const reponseGuardians = response.data;

        if (reponseGuardians.length > 0) {
          for (const key in reponseGuardians) {
            loadedGuardians[key] = reponseGuardians[key];
          }
        }

        setGuardians(loadedGuardians);
      }
    }
  }, [response, error, reload, graveId]);

  function getGuardiansList() {
    const url = "grave/" + graveId + "/assignment/guardian/list";
    setEndpoint(url);

    const data = {};

    request({
      method: "POST",
      url: url,
      data,
    });
  }

  const guardianAssignHandler = () => {
    getGuardiansList();
  };

  const guardianRemoveHandler = () => {
    getGuardiansList();
  };

  return (
    <Wrapper>
      <section className="rl-admin-content">
        
        <PanelContentTop rlSideBar={rlSideBar} itemLength={guardians.length}/>

        <div className="rl-admin-content-7-3">
          <PanelGuardianForm assignGuardian={guardianAssignHandler} rlSideBar={rlSideBar} count={guardians.length}/>
          <PanelGuardianChart count={guardians.length} total={5} />
        </div>
        {guardians.length > 0 ? (
          <PanelGuardianList
            reloadList={guardianRemoveHandler}
            items={guardians}
          />
        ) : (
          // <RLEmptyListCard />
          <div></div>
        )}
      </section>
    </Wrapper>
  );
};

export default PanelGuardian;
